import { take } from 'rxjs/operators';
/**
 * This is a rxjs v6 compatible version of https://rxjs.dev/api/index/function/lastValueFrom.
 * @public
 * @remarks It should be removed once rxjs is updated to v7
 * @param obs - Observable to turn into Promise
 * @returns
 */
export async function lastValueFrom(obs) {
    return obs.pipe(take(1)).toPromise();
}
